import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["input", "results", "code", "description", "preview"]

  connect() {
    this.debounce = null
  }

  search() {
    clearTimeout(this.debounce)
    const q = this.inputTarget.value.trim()
    if (q.length < 2) {
      this.clearResults()
      return
    }
    this.debounce = setTimeout(() => this.fetchResults(q), 250)
  }

  async fetchResults(q) {
    const url = this.element.dataset.searchUrl + "?q=" + encodeURIComponent(q)
    const response = await fetch(url, { headers: { Accept: "application/json" } })
    const results = await response.json()
    this.renderResults(results)
  }

  renderResults(results) {
    this.resultsTarget.innerHTML = ""
    if (results.length === 0) {
      this.resultsTarget.classList.add("d-none")
      return
    }
    results.forEach(({ code, description }) => {
      const item = document.createElement("button")
      item.type = "button"
      item.className = "list-group-item list-group-item-action py-2"
      item.innerHTML = `<span class="fw-bold font-monospace me-2">${code}</span><span class="text-muted">${description}</span>`
      item.addEventListener("click", () => this.select(code, description))
      this.resultsTarget.appendChild(item)
    })
    this.resultsTarget.classList.remove("d-none")
  }

  select(code, description) {
    this.codeTarget.value = code
    this.descriptionTarget.value = description
    this.inputTarget.value = `${code} — ${description}`
    this.clearResults()
    if (this.hasPreviewTarget) {
      this.previewTarget.classList.remove("d-none")
      this.previewTarget.querySelector("[data-preview-code]").textContent = code
      this.previewTarget.querySelector("[data-preview-description]").textContent = description
    }
    const submit = this.element.querySelector("[data-icd-search-submit]")
    if (submit) submit.disabled = false
  }

  preventBlur(event) {
    event.preventDefault()
  }

  blur() {
    setTimeout(() => this.clearResults(), 150)
  }

  clearResults() {
    this.resultsTarget.innerHTML = ""
    this.resultsTarget.classList.add("d-none")
  }
}
